import React from 'react';
import PropTypes from 'prop-types';
import Testimonial from './testimonial/testimonial';
import QuoteSlider from './quote-slider/quote-slider';
import { Container } from '../styled/containers';
import { ModuleWrapper, Title } from './testimonial/styles';
import { useLayout } from '../layout/context';

export const isOdd = (i) => i % 2 !== 0;

const Testimonials = ({
  headerText,
  testimonials = [],
  quoteSlider,
  removeMarginBottom,
  contentfulId,
}) => {
  const { insideContainer, insideSideBar = false } = useLayout();

  if (testimonials === null || testimonials.length === 0) {
    return null;
  }

  if (quoteSlider === true) {
    return (
      <ModuleWrapper
        removeMarginBottom={removeMarginBottom}
        aria-labelledby="carouselheading"
      >
        <Container $padding={!insideContainer}>
          {headerText ? <Title>{headerText}</Title> : null}
          <QuoteSlider
            quotes={testimonials}
            sidebar={insideSideBar}
            contentfulId={contentfulId}
          />
        </Container>
      </ModuleWrapper>
    );
  }
  return (
    <ModuleWrapper removeMarginBottom={removeMarginBottom}>
      <Container $padding={!insideContainer}>
        {headerText ? <Title>{headerText}</Title> : null}
        {testimonials.map((testimonial, i) => (
          <Testimonial
            data={testimonial}
            isOdd={isOdd(i)}
            sidebar={insideSideBar}
            key={i}
          />
        ))}
      </Container>
    </ModuleWrapper>
  );
};

Testimonials.propTypes = {
  headerText: PropTypes.string,
  testimonials: PropTypes.array.isRequired,
  contentfulId: PropTypes.string.isRequired,
  quoteSlider: PropTypes.bool.isRequired,
  removeMarginBottom: PropTypes.bool,
};

export default Testimonials;

export const TestimonialsAssembly = ({ contentfulData }) => (
  <Testimonials
    contentfulId={contentfulData.contentful_id}
    headerText={contentfulData.headerText}
    testimonials={contentfulData.testimonials}
    quoteSlider={contentfulData.quoteSlider}
    removeMarginBottom={contentfulData.removeMarginBottom}
  />
);

TestimonialsAssembly.propTypes = {
  contentfulData: PropTypes.object,
};
